import { useQuery } from "@tanstack/react-query";
import type { ScenarioForecastResponseApi } from "@/api/models/scenario";
import { getScenarioForecast } from "@/api/services/scenarioService";
import { useApp } from "@/contexts/AppContext";

export function useScenarioForecast(
  scenarioId: number | string,
  period: string,
) {
  const { mode } = useApp();
  const isLive = mode === "live";
  const numericId = Number(scenarioId);
  const enabled = isLive && !isNaN(numericId);

  return useQuery<ScenarioForecastResponseApi>({
    queryKey: ["scenario-forecast", numericId, period],
    queryFn: () => getScenarioForecast(numericId, period),
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
